export const errorThrow = pError => {
    if (pError) {
        throw new Error(pError);
    }
};

const errors = { errorThrow };

export default errors;
